import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonIcon from "@mui/icons-material/Person";
import { Localized } from "@fluent/react";
import { Link } from "react-router-dom";
import styles from "./NavListItems.module.css";
import { Divider } from "@mui/material";
import GroupAddIcon from '@mui/icons-material/GroupAdd';

interface navProps {
	admin?: boolean,
}

export default function Navigation({ admin }: navProps) {
	return <div>
		{admin ? <>
			<Link to="/dashboard" className={styles.removeStyle}>
				<ListItem button>
					<ListItemIcon>
						<DashboardIcon />
					</ListItemIcon>

					<Localized id="dashboard-navlink-dashboard" attrs={{ primary: true }}>
						<ListItemText />
					</Localized>

				</ListItem>
			</Link>

			<Link to="/alarm-group" className={styles.removeStyle}>
				<ListItem button>
					<ListItemIcon>
						<GroupsIcon />
					</ListItemIcon>
					<Localized id="dashboard-navlink-alarm-group" attrs={{ primary: true }}>
						<ListItemText />
					</Localized>

				</ListItem>
			</Link>

			<Link to="/invite-users" className={styles.removeStyle}>
				<ListItem button>
					<ListItemIcon>
						<GroupAddIcon />
					</ListItemIcon>
					<Localized id="dashboard-navlink-invite-users" attrs={{ primary: true }}>
						<ListItemText />
					</Localized>

				</ListItem>
			</Link>
			<Link to="/invitationsummary" className={styles.removeStyle}>
				<ListItem button>
					<ListItemIcon>
						<DashboardIcon />
					</ListItemIcon>

					<Localized id="dashboard-navlink-invitations" attrs={{ primary: true }}>
						<ListItemText />
					</Localized>

				</ListItem>
			</Link>
			<Divider />
		</>
			: null}
		<div>
			<Link to="/profile" className={styles.removeStyle}>
				<ListItem button>
					<ListItemIcon>
						<PersonIcon />
					</ListItemIcon>

					<Localized id="dashboard-navlink-my-profile" attrs={{ primary: true }}>
						<ListItemText />
					</Localized>

				</ListItem>
			</Link>
		</div>


	</div>
}
